import { useCallback, useEffect, useState } from "react";
import { linienverlaufHeader } from "../Tabellen/ConstTabKopf/LinienverlaufKopf";
import GeneralTable from "../Tabellen/GeneralTable";
import InformationCell from "../Tabellen/InformationCell";
import LinienführungUpdate from "./LinienführungUpdate";
import { useNavigate } from "react-router-dom";
import { MyNewButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export function Linienführung({ linienInstance, jahrInstance, linienVerlInstance, setTable, goBack, bhfInstance, strVerlInstance, strInstance }) {
    const [dataJahre, setDataJahre] = useState([]);
    const [dataLinien, setDataLinien] = useState([]);

    const [selectLinien, setSelectLinien] = useState(false);
    const [clicked, setClicked] = useState({});
    const [searching, setSearching] = useState("");
    const [filteredData, setFilteredData] = useState();

    const [usedFilter, setUsedFilter] = useState(new MonitorApi.BodyLinienverlaufFilter());

    const navigate = useNavigate();

    useEffect(() => {

        const loadJahre = () => {
            jahrInstance.getPresentYears((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    console.log('>>jahre geladen');
                    setDataJahre(data);
                }
            });
        };

        const loadLinien = () => {
            setClicked({});
            linienInstance.getLinieLinieGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    console.log('>>load linien');
                    data.map(linie => setClicked(previous => ({ ...previous, [linie.id]: 'inactive' })));
                    setDataLinien(data);
                }
            });
        };
        loadJahre();
        loadLinien();
    }, [setDataJahre, jahrInstance, setDataLinien, linienInstance]);

    const selectMinYear = event => {
        setUsedFilter({
            ...usedFilter,
            minJahr: event.target.value
        });
    }

    const selectMaxYear = event => {
        setUsedFilter({
            ...usedFilter,
            maxJahr: event.target.value
        });
    }

    const changeLinienState = event => {
        setSelectLinien(event.target.checked);
        console.log(event.target.checked)
        if (event.target.checked) {
            console.log('wurde angehakt')
            Object.keys(clicked).map(l => setClicked(previous => ({ ...previous, [l]: 'active' })));
        } else {
            console.log('wurde abgehakt')

            Object.keys(clicked).map(l => setClicked(previous => ({ ...previous, [l]: 'inactive' })));
        }
    };

    const changeCollection = event => {
        event.preventDefault();
        if (clicked[event.target.id] === 'inactive') {
            setClicked(previous => ({ ...previous, [event.target.id]: 'active' }));
            if (Object.keys(clicked).filter(l => l !== event.target.id).filter(l => clicked[l] === 'inactive').length === 0) {
                setSelectLinien(true);
            }
        } else {
            setClicked(previous => ({ ...previous, [event.target.id]: 'inactive' }));
            setSelectLinien(false);
        }

    };

    const handleLinienCollection = useCallback((usedFilter) => {
        if (Object.keys(clicked).filter(k => clicked[k] === 'active').length === 0) {
            setUsedFilter({
                ...usedFilter,
                idsLinien: dataLinien.map(linie => linie.id)
            });
        } else {
            setUsedFilter({
                ...usedFilter,
                idsLinien: Object.keys(clicked).filter(k => clicked[k] === 'active')
            });
        }
    }, [clicked, dataLinien, setUsedFilter])

    useEffect(() => {
        handleLinienCollection();
    }, [clicked, handleLinienCollection]);

    const loadingTable = (filter) => {
        console.log("filter: ", filter)
        linienVerlInstance.getFilteredLinienverlaufLinienverlaufPatch(filter, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                setFilteredData(data);
                console.log("data: ", data)
            }
        });
    }

    const go = event => {
        event.preventDefault();
        setFilteredData();
        loadingTable(usedFilter);
    };

    const [showFilter, setShowFilter] = useState(false);

    function resetFilter(e) {
        e.preventDefault();
        setFilteredData();
        setUsedFilter({
            ...usedFilter,
            minJahr: undefined,
            maxJahr: undefined
        });
    }

    function linkToNew(event) {
        event.preventDefault();
        navigate(`../linienführung-anlegen`, {replace: true});
    }

    // const close = event => {
    //     setFilteredData(null);
    //     setUsedFilter({
    //         ...usedFilter,
    //         minJahr: undefined,
    //         maxJahr: undefined
    //     });
    //     setTable('');
    //     goBack();
    // }

    const updateCol = {
        id: "update",
        Header: '',
        keyword: 'Änderungen',
        Cell: ({ row }) => (
            <div>
                <LinienführungUpdate
                    rowEntry={row}
                    reload={loadingTable}
                    usedFilter={usedFilter}
                    linienVerlInstance={linienVerlInstance}
                />
            </div>
        )
    }
    const commCol = {
        id: "comment",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }
    return (
        <div className="lf-komplett">
            <MyNewButton onClick={e => linkToNew(e)}>&#43; neue Linienführung</MyNewButton>
            <section >
                {/* {JSON.stringify(usedFilter)} */}
                {!filteredData ? <form>
                    <div className="jahre">
                        <legend><h4>Zeitraum auswählen:</h4></legend>
                        <label>von: <select onChange={selectMinYear}>
                            <option hidden>---Start wählen---</option>
                            {dataJahre.map(jahr => <option key={jahr} value={jahr}>{jahr}</option>)}
                        </select></label>
                        <label>bis: <select onChange={selectMaxYear}>
                            <option hidden>---Ende wählen---</option>
                            {dataJahre.filter(jahr => jahr >= usedFilter.minJahr).map(jahr => <option key={jahr} value={jahr}>{jahr}</option>)}
                        </select></label>
                    </div>

                    <section className="linien" onMouseLeave={() => setShowFilter(false)} >
                        <legend><h4>Linie auswählen:</h4></legend>
                        <div >
                            <label id={0}><input type="checkbox" id={0} checked={selectLinien} onChange={changeLinienState} />Alle Linien</label>
                            <input onMouseEnter={() => setShowFilter(true)} type="search" id="search-linie" placeholder="Liniensuche..." value={searching} onChange={(event) => setSearching(event.target.value)} />
                        </div>
                        {/* https://www.freecodecamp.org/news/search-and-filter-component-in-reactjs/ */}
                        {showFilter && <div className="abs"><ul type="none" className="bttn-linien-liste" onMouseLeave={() => setShowFilter(false)}>
                            {dataLinien.filter(data => data.linie.toLowerCase().indexOf(searching.toLowerCase()) > -1).map(linie => <li key={linie.id}>
                                <button id={linie.id} value={linie.linie} onClick={changeCollection} className={`${clicked[linie.id]} bttn-linie`}>{linie.linie}</button>
                            </li>
                            )}
                        </ul></div>}
                    </section>


                    {/* <aside style={{ fontSize: "small" }}>gewählte Linien: {JSON.stringify(clicked)}</aside>
                    <aside style={{ fontSize: "small" }}>gewählte Jahre: {JSON.stringify(checkboxes)}</aside> */}
                    <button className="filter-bttn" onClick={go}>&#8618; Filter anwenden</button>
                </form>
                    : <section>
                        {/* {`${filteredData}`}  */}
                        <GeneralTable data={filteredData} columns={linienverlaufHeader} hiddenColumns={['id', 'id_linie', 'id_strecke_hr', 'id_strecke_rr']} additionalColumns={[commCol, updateCol]} />
                        <button className="new-filter-bttn" onClick={(e) => resetFilter(e)}>&#8617; neuer Filter</button>
                    </section>}
                <br></br>
                {/* <button onClick={close}>Tabelle schließen</button> */}
            </section>
        </div>
    );
}